import * as yup from 'yup';
import {
  COMPANY_MIN_LENGTH,
  COMPANY_MAX_LENGTH,
  COMPANY_VALID_CHARS_REGEX,
} from '../../shared/constants';
import { PHONE_REG_EXP } from '../../shared/constants';
import {
  DATE_FORMAT_OPTIONS,
  LOCALE_OPTIONS,
} from './preferencesOptions';

export const userSettingsValidationSchema = yup.object({
  phoneNumber: yup
    .string()
    .required('Phone number is required')
    .matches(
      PHONE_REG_EXP,
      'Please enter at least 10 digits (e.g., +1234567890)',
    ),

  companyName: yup
    .string()
    .min(COMPANY_MIN_LENGTH, 'Company name must be at least 2 characters')
    .max(COMPANY_MAX_LENGTH, 'Company name must be less than 100 characters')
    .matches(
      COMPANY_VALID_CHARS_REGEX,
      "Only letters, numbers, spaces, and special characters (&, ., ,, -, ', /, +) are allowed",
    ),
  locale: yup
    .string()
    .optional()
    .oneOf(
      [...LOCALE_OPTIONS.map(option => option.value), ''],
      'Please select a valid language',
    ),
  zoneInfo: yup.string().optional(),
  dateFormat: yup
    .string()
    .optional()
    .oneOf(
      [...DATE_FORMAT_OPTIONS.map(option => option.value), ''],
      'Please select a valid date format',
    ),
  is24HourFormat: yup.boolean().optional().nullable(),
});

export type UserFormData = yup.InferType<typeof userSettingsValidationSchema>;
